import { render, staticRenderFns } from "./KnowledgeBaseSync.vue?vue&type=template&id=2aacef1c&scoped=true&"
import script from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseSync.vue?vue&type=style&index=0&id=2aacef1c&scoped=true&lang=css&"
import style1 from "./KnowledgeBaseSync.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aacef1c",
  null
  
)

export default component.exports